import OffersItem from './offers-item';

export default OffersItem;
